import React from "react";
import {PagesHero, SEO, ServicesDetails} from "../components";
import {servicesDataDetailed} from "../constants/Services";

const Services = () => {
  return (
    <main>
      <SEO
        title="Web Development Services by Deep Kapadia | React, Next.js, Figma to Code"
        description="Explore Deep Kapadia's professional frontend and full-stack web development services — from Figma to HTML, API integrations, custom components, CMS setup, performance optimization, and long-term support."
        keywords="Web Development Services, React Developer, Figma to HTML, Next.js Development, Frontend Services, API Integration, CMS Integration, Full Stack Developer India, Component Architecture, Performance Optimization, Ongoing Web Support, Deep Kapadia Services"
        image="https://www.deepkapadia.work/images/preview.jpg"
        url="https://www.deepkapadia.work/services"
      />

      <PagesHero
        subTitle="What I Do"
        title="My Services"
        otherText1="From design to development,"
        otherText2="I build digital experiences that make an impact."
        maskSubTitle="Tailored Solutions"
        maskTitle="Services"
        maskOtherText1="Looking for a reliable developer?"
        maskOtherText2="Let’s bring your vision to life together."
      />
      <ServicesDetails servicesData={servicesDataDetailed} />
    </main>
  );
};

export default Services;
